'use strict';

import Events from 'events/events';

function init() {
  let sortSelectForm = document.querySelector('.product-sort');
  if (sortSelectForm) {
    let sortSelectField = sortSelectForm.querySelector('select');
    let sortSelectButton = sortSelectForm.querySelector('button');
    let submitButton = document.getElementById("button--product-sort-submit"); 
    if (submitButton) {
      submitButton.removeAttributeNode(submitButton.getAttributeNode('tabindex'));
    }      
    sortSelectField.addEventListener('change', function() {
      sortSelectButton.click();
    });
  }
}

if ('querySelector' in document) {
  init();
  Events.sortSelectReinit.register(init);
}
